import Vue from 'vue'
import firebase from "firebase";

const state = {
  user: false,
  admins: [],
  client: false,
  contracts: [],
  projects: [],
  appointments: [],
  panelists: [],
  posts: [],
  phoneSessions: [],
  requests: [],
  survey: false,
  surveys: [],
  surveyResponses: [],
  projectAvailability: [],
  organisations: [],
  projectSlots: [],
  videoCompositions: []
}

const actions = {
  bindAnything({ commit, state }, {id, collection, then, reference} ) {
    if( !id ){
      return;
    }
    let exists = state[reference].find( a => a.id == id );
    if( !exists ){    
      firebase.firestore().collection(collection).doc(id).onSnapshot(snapshot => {
        if( snapshot.exists ){
            let data = snapshot.data();
            data.bound = true;
            commit(then, { id: snapshot.id, data: data, reference: reference });
        }        
      });
      return true;
    }
    return false;
  },
  fetchVideoCompositions({dispatch}, appointmentId ){
    firebase.firestore().collection("videoCompositions")
      .where("appointment", "==", appointmentId)
      .onSnapshot( snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "videoCompositions", then: "SET_ANYTHING", reference: "videoCompositions"} )
        })
      })
  },  
  fetchPost({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "posts", then: "SET_ANYTHING", reference: "posts" } )
  },
  fetchClientUserLogo({state}, organisationId ){
    var storage = firebase.storage();
    storage.ref("logos/" + organisationId + ".jpg").getDownloadURL().then( (img) =>{
      Vue.set( state.user, "logo", img );
    });    
  },
  fetchUser({dispatch, state}){
    firebase.firestore().doc("users/"+ firebase.auth().currentUser.uid ).onSnapshot( snapshot => {
      if( snapshot.exists ){
        let data = snapshot.data();
        data.id = snapshot.id;       
        if( data.organisation ){
          dispatch("fetchOrganisation", data.organisation);
          dispatch("fetchClientUserLogo", data.organisation)
        }
        Vue.set( state, "user", data );
      } 
    })
  },
  fetchSurveyResponses({dispatch}, id ){
    firebase.firestore().collection("surveyResponses")
      .where("survey", "==", id)
      .onSnapshot(snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "surveyResponses", then: "SET_ANYTHING", reference: "surveyResponses"} )
          dispatch("bindAnything", {id: doc.data().participant, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
        })
      })
  },  
  bindSurvey({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "surveys", then: "SET_ANYTHING", reference: "surveys" } )
  },
  fetchProjectSlots({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "projectSlots", then: "SET_ANYTHING", reference: "projectSlots" } )
  },  
  fetchProjectAppointments({dispatch}, {id, limitedTo} ){
        var query = firebase.firestore().collection("appointments")
          .where("publishStatus", "==", "live")
          .where("project", "==", id)
          .where("showToClient", "==", true )
        if( limitedTo ){
          query = query.where("users."+limitedTo, "==", "client" )
        }
        query.onSnapshot(snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
          let appointment = doc.data();
          if( appointment.participant ){
            dispatch("bindAnything", {id: appointment.participant, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
          }
        })
      })
  },  
  fetchAppointment({dispatch}, {id} ){
    firebase.firestore().doc("appointments/" + id ).get().then( doc => {
      dispatch("bindAnything", {id: doc.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
      let appointment = doc.data();
      if( appointment.participant ){
        dispatch("bindAnything", {id: appointment.participant, collection: "users", then: "SET_ANYTHING", reference: "panelists"} )
      }
    })
  },  
  fetchContracts({dispatch}, id ){
    firebase.firestore().collection("contracts")
      .where("organisation", "==", id)
      .onSnapshot(snapshot => {
        snapshot.forEach( doc => {
          dispatch("bindAnything", {id: doc.id, collection: "contracts", then: "SET_ANYTHING", reference: "contracts"} )
        })
      })
  },
  fetchRequest({dispatch,  commit }, id ){
    firebase.firestore().collection("requests").doc(id).onSnapshot(doc => {
      let request = doc.data();
      request.bound = true;
      commit("SET_ANYTHING", { id: id, data: request, reference: "requests" });
      if( request.contract ){
        dispatch("bindAnything", {id: request.contract, collection: "contracts", then: "SET_ANYTHING", reference: "contracts"} )
      }
      let admins = Object.keys( request.users ).filter( key => request.users[key] == 'admin' );
      admins.forEach( u => {
        dispatch("bindAnything", {id: u, collection: "users", then: "SET_ANYTHING", reference: "admins"} )
      })
    });
  },
  bindProject({dispatch, state, commit }, id ){
    let exists = state.projects.filter( p => p.bound == true).find( p => p.id == id );
    if( !exists ){    
      firebase.firestore().collection("projects").doc(id).onSnapshot(doc => {
        let project = doc.data();
        project.bound = true;
        commit("SET_ANYTHING", { id: id, data: project, reference: "projects" });
        dispatch("bindAnything", {id: id, collection: "projectAvailability", then: "SET_ANYTHING", reference: "projectAvailability"} )
        var permissions = project.permissions;
        if( !permissions || !permissions[limitedTo] ){
        var limitedTo = firebase.auth().currentUser.uid;
          limitedTo = false;
        }              
        else{
          if( permissions[limitedTo]["view-all-appointments"] ){
            limitedTo = false;
          }
        }
        dispatch("fetchProjectAppointments", {id, limitedTo } )
        if( project.screener ) {
          dispatch("bindSurvey", project.screener )
        }
        let admins = Object.keys( project.users ).filter( key => project.users[key] == 'admin' );
        admins.forEach( u => {
          dispatch("bindAnything", {id: u, collection: "users", then: "SET_ANYTHING", reference: "admins"} )
        })
      });
    }    
  },
  trackPhoneSession({commit}, sessionId ){
    firebase.firestore().collection("phoneSessions").doc(sessionId).onSnapshot(doc => {
      commit("SET_ANYTHING", {id: doc.id, data: doc.data(), reference: "phoneSessions" })
    })
  },
  fetch( {commit}, reference ){
    if( ['panelists', 'admins', 'clients'].indexOf( reference ) > -1 ){
      firebase.firestore().collection("users")
        .where("publishStatus", "==", "live" )
        .where("role", "==", reference.substr(0, reference.length - 1) )
        .orderBy("updated", "desc")
        .onSnapshot(snapshot => {
          snapshot.forEach(doc => {
            let o = doc.data();
            o.bound = false;
            commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
          });
      })      
    }
    if( reference == "projects" || reference == "requests"){
      firebase.firestore().collection(reference)
        .where("users."+firebase.auth().currentUser.uid, "==", "client")
        .onSnapshot(snapshot => {
          snapshot.forEach(doc => {
            let o = doc.data();
            o.bound = false;
            commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
          });
      })
    }
    else{
      firebase.firestore().collection(reference)
        .where("publishStatus", "==", "live" )
        .orderBy("updated", "desc")
        .onSnapshot(snapshot => {
          snapshot.forEach(doc => {
            let o = doc.data();
            o.bound = false;
            commit("SET_ANYTHING", { id: doc.id, data: o, reference: reference });
          });
      })
    }
  },
  fetchMyProjects({ dispatch } ) {
    firebase.firestore().collection("projects")
      .where("active", "==", true )
      .where("status", "==", "open" )
      .where("users."+firebase.auth().currentUser.uid, "==", "client")
      .onSnapshot(snapshot => {
        snapshot.forEach(doc => {
          dispatch("bindProject", doc.id )      
        });
    })
  }, 
  fetchOrganisation( {commit}, id){
    firebase.firestore().doc("organisations/" + id ).get().then((doc) => {
      var data = doc.data();
      var id = doc.id;
      commit( "SET_ANYTHING", {id, data, reference: "organisations" })
    })
  }
};

const mutations = {
  SET_ANYTHING(state, {id, data, reference}) {
    if( !id ){ return; }
    if( typeof data == 'undefined') { return; }
    if( !state[reference] ) { return; }
    let index = state[reference].length;
    data.id = id;
    let exists = state[reference].find( p => p.id == id );
    if( exists ){
      index = state[reference].indexOf( exists )
    }
    Vue.set( state[reference], index, data );
  } 
};



export default {
  // modules: {
  //   Projects,
  // },
  state,
  actions,
  mutations,
};
